Poi =  {

	list : false

	init : ->
		console.log 'Poi init'

		options = {
			valueNames: [
				{ data: ['type'] }
			]
		}

		@list = new List('poi--list', options);

		# @list.on "filterStart",  ->

		@filterManager()

	filterManager : ->
		
		_this = @

		$('.poi--filter').on "click", (ev) ->
			if $(@).hasClass('selected')
				$(@).removeClass('selected')
			else
				$(@).addClass('selected')

			selectedFilters = []
			
			$.each $('.poi--filter'), (i, elt) ->
				if $(elt).hasClass('selected')
					selectedFilters.push($(elt).attr('data-filter'))
			

			if selectedFilters.length
				_this.list.filter (item) ->
					if selectedFilters.indexOf(item.values().type) > -1
						return true
					else
						return false
			else
				_this.list.filter()

			$('#poi--list ul').append('<li class="poi--item empty"></li>')
			$('#poi--list ul').append('<li class="poi--item empty"></li>')

	destroy : ->
		console.log "Poi destroy"
		
}